PJQ.views.meetings.MeetingEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-meeting-edit'),
        subTemplates: {
            agendaItems: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'agenda-items'),
            agendaItem: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'agenda-item')
        },
        width: '95%',
        maxWidth: 1200,
        minWidth: 700,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveMeeting',
        'click .btn-delete': 'deleteMeeting',
        'click .btn-close': 'close',
        'click .nav-link': 'changeActiveView',
        'click .btn-add-agenda-item': 'addAgendaItemClicked',
        'click .btn-close-agenda-item': 'closeAgendaItemClicked',
        'click .btn-open-agenda-item': 'openAgendaItemClicked',
        'click .btn-edit-agenda-item': 'editAgendaItemClicked',
        'click .btn-delete-agenda-item': 'deleteAgendaItemClicked',
        'click .btn-add-category': 'addCategoryClicked',
        'click .btn-edit-category': 'editCategoryClicked',
        'click .btn-delete-category': 'deleteCategoryClicked',
        'click .btn-edit-minutes': 'editMeetingMinutes',
        'click .btn-save-minutes': 'saveMeetingMinutesClicked',
        'click .category-dropdown': 'categoryClicked',
        'click .btn-view-transcription': 'viewTranscription',
        'click .btn-export': 'exportMeeting',
        'click .btn-cancel-minutes': 'cancelMeetingMinutes',
        'keydown .meeting-number': 'numbersOnly',
        'click .btn-distribute': 'distributeAgendaItems',
        'click .btn-distribute-manual': 'distributeAgendaItemsManual',
        'click .btn-view-previous-minutes': 'viewPreviousMinutes',
        'click .toggle-attendance': 'toggleAttendance',
        'input .meeting-description': 'descriptionChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.model == null) {
            this.model = new PJQ.models.meetings.Meeting({
                projectId: this.options.project?.id,
                templateId: this.options.templateId,
                statusId: 1,
                number: 1
            });
        }

        if (this.options.project) {
            this.customFields = await this.options.project.fetchMeetingCustomFields();
        } else {
            this.customFields = await PJQ.app.session.fetchMeetingCustomFields();
        }

        if (this.options.project) {
            this.settings = await this.options.project.fetchMeetingSettings();
        } else {
            this.settings = await PJQ.app.session.fetchMeetingSettings();
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        } else {
            this.model.set('isPublic', this.settings.get('isPublicDefault'));
        }

        if (_.size(this.model.get('timezone')) === 0) {
            this.model.set('timezone', new Date().toLocaleTimeString('en-us', {timeZoneName: 'short'}).split(' ')[2]);
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let status = this.model.get('statusId');
        if (this.options.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
            this.options.canSave = this.options.canEdit && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
            this.options.canUploadRecording = PJQ.app.session.project.hasPermission('meetings.canEdit')
                && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED
                && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = this.options.isAdmin;
            this.options.canSave = this.options.canEdit && status !== PJQ.constants.meetings.meetingStatus.CONCLUDED && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
            this.options.canUploadRecording = status !== PJQ.constants.meetings.meetingStatus.CONCLUDED
                && status !== PJQ.constants.meetings.meetingStatus.CANCELLED;
        }

        this.options.canEditMinutes = (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit')) &&
            status !== PJQ.constants.meetings.meetingStatus.CONCLUDED &&
            status !== PJQ.constants.meetings.meetingStatus.CANCELLED;

        if (status === PJQ.constants.meetings.meetingStatus.IN_PROGRESS || status === PJQ.constants.meetings.meetingStatus.CONCLUDED || status === PJQ.constants.meetings.meetingStatus.CANCELLED) {
            this.options.canEdit = false;
            this.options.canDelete = false;
            this.options.canUploadRecording = status === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'));
        } else if (status === PJQ.constants.meetings.meetingStatus.DRAFT) {
            this.options.canEdit = true;
            this.options.canUploadRecording = true;
        } else {
            if (PJQ.app.session.project) {
                this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
                this.options.canDelete = PJQ.app.session.project.hasPermission('meetings.isAdmin');
                this.options.canUploadRecording = PJQ.app.session.project.hasPermission('meetings.canEdit');
            } else {
                this.options.canEdit = true;
                this.options.canDelete = true;
                this.options.canUploadRecording = true;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            canSave: this.options.canSave,
            settings: this.settings,
            canTranscribe: _.size(_.filter(this.model.meetingRecordings.models, function (recording) {
                return !recording.get('delete')
            }, this)) > 0 && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_MEETING_TRANSCRIPTIONS)
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
        if (!this.model.isNew()) {
            this.renderAgendaItems();
        }
    },
    descriptionChanged: function(e) {
        let $input = $(e.currentTarget),
            val = $input.val();

        if (typeof val === 'string' && val.length > 4000) {
            val = val.slice(0, 4000);
            $input.val(val);
        }

        this.model.set('description', val);
    },
    viewPreviousMinutes: function (e) {
        let $target = $(e.currentTarget),
            $container = $target.closest('.agenda-item-container'),
            $minutes = $container.find('.previous-minutes-display');

        $minutes.off('shown.bs.collapse hidden.bs.collapse').on('shown.bs.collapse hidden.bs.collapse', function () {
            if ($minutes.hasClass('show')) {
                $container.find('.btn-view-previous-minutes').html('<i class="fas fa-angle-up mr-1"></i>');
            } else {
                $container.find('.btn-view-previous-minutes').html('<i class="fas fa-angle-down mr-1"></i>');
            }
        });

        $minutes.collapse('toggle');
    },
    changeActiveView: function (e, view) {
        let tab = e && e.target.hash ? e.target.hash.toUpperCase() : null;

        if (view) {
            tab = view;
        }

        switch (tab) {
            case '#M_AGENDA':
                this.options.activeView = 'agenda';
                break;
            default:
                this.options.activeView = 'general';
        }
    },
    renderGeneral: function () {
        let fnSaveAttachment = _.bind(function (attachment) {
            // If the attachment doesn't have an uploadId, recursively call this function every 2 seconds
            if (attachment.get('uploadId')) {
                let isNew = this.model.isNew();
                this.model.save(null, {
                    success: _.bind(function (model) {
                        if (isNew && typeof this.options.onSave === 'function') {
                            this.options.onSave(model, true);
                        }
                        this.render();
                    }, this)
                });
            } else {
                setTimeout(_.bind(function () {
                    fnSaveAttachment(attachment)
                }, this), 2000);
            }
        }, this);

        this.listenTo(this.model.meetingRecordings, 'add', _.bind(function (attachment) {
            // The attachment has been uploaded, but probably doesn't have an uploadId yet. Call fnSaveAttachment to make sure it saves
            if (attachment.get('uploadId')) {
                model.save();
            } else {
                fnSaveAttachment(attachment);
            }
        }, this));
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });
        let defaultDate = PJQ.helpers.dateHelpers.getDateString(this.model.get('date'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        this.datePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-date'),
            canEdit: this.options.canEdit,
            timezone: 'UTC',
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: defaultDate
            },
            onChange: _.bind(function (newDate) {
                let currentDate = this.model.get('date');
                if (currentDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDate)) !== 0) {
                    this.model.set('date', newDate);
                }
            }, this)
        });

        if (_.size(this.customFields) > 0) {
            this.meetingCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.meeting-custom-fields'),
                isAdmin: true,
                isEdit: this.options.canEdit,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: () => {
                    this.model.isDirty = true;
                }
            });
        }

        // Convert startTime to date for datepicker
        let startTimeString = this.model.get('startTime'),
            [startHours, startMinutes, startSeconds] = startTimeString ? startTimeString.split(':') : [0, 0, 0],
            startDate = new Date();
        startDate.setHours(startHours);
        startDate.setMinutes(startMinutes);
        startDate.setSeconds(startSeconds);

        this.startTimePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-start-time'),
            canEdit: this.options.canEdit,
            isTimeOnly: true,
            timezone: this.model.get('timezone'),
            isShowTimezone: true,
            isEditTimezone: true,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                defaultDate: startDate
            },
            onTimezoneChange: (tz) => {
                this.model.set('timezone', tz);
                this.endTimePicker.setTimezone(tz);
            },
            onChange: (newDate) => {
                let time = PJQ.helpers.dateHelpers.getTimeString(new Date(newDate));
                if (this.model.get('startTime') === time) {
                    return;
                }

                this.model.set('startTime', time)

                let dMinutes = this.model.durationInMinutes();
                if (dMinutes < 0) {
                    let startTime = this.model.getDateAndTime('start');
                    this.model.set('endTime', PJQ.helpers.dateHelpers.getTimeString(startTime));

                    if (this.endTimePicker) {
                        this.endTimePicker.setValue(startTime)
                    }
                }
            }
        });

        // Convert endTime to date for datepicker
        let endTimeString = this.model.get('endTime'),
            [endHours, endMinutes, endSeconds] = endTimeString ? endTimeString.split(':') : [0, 0, 0],
            endDate = new Date();
        endDate.setHours(endHours);
        endDate.setMinutes(endMinutes);
        endDate.setSeconds(endSeconds);

        this.endTimePicker = new PJQ.inputs.Datepicker({
            el: this.$('.meeting-end-time'),
            canEdit: this.options.canEdit,
            isTimeOnly: true,
            timezone: this.model.get('timezone'),
            isShowTimezone: true,
            isEditTimezone: true,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME,
                defaultDate: endDate
            },
            onTimezoneChange: (tz) => {
                this.model.set('timezone', tz);
                this.startTimePicker.setTimezone(tz);
            },
            onChange: (newDate) => {
                let time = PJQ.helpers.dateHelpers.getTimeString(new Date(newDate));
                if (this.model.get('endTime') === time) {
                    return;
                }

                this.model.set('endTime', time)

                let dMinutes = this.model.durationInMinutes();
                if (dMinutes < 0) {
                    let endTime = this.model.getDateAndTime('end');
                    this.model.set('startTime', PJQ.helpers.dateHelpers.getTimeString(endTime));

                    if (this.startTimePicker) {
                        this.startTimePicker.setValue(endTime)
                    }
                }
            }
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 1,
            canEdit: ((!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit')) || this.options.canEdit),
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newStatus = value,
                    oldStatus = this.model.get('statusId');
                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.model.dirtyAttributes = {};
                            if (typeof this.options.onSave === 'function')
                                this.options.onSave(this.model);
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: 'Meeting saved successfully'
                            });
                        }, this)
                    })
                }
            }, this)
        });

        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.DRAFT || this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.SCHEDULED) {
            this.attendeePicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.meeting-attendees'),
                selectedContact: this.model.attendees.getAttendeeContacts(),
                isReadOnly: !this.options.canEdit,
                displayContactsBlock: true,
                context: PJQ.app.session.project ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    let arr = _.map(selectedContacts, function (contact) {
                        return contact.get('id') ? contact.get('id') : contact.id;
                    });
                    this.model.set('attendeeIds', arr);
                    this.model.attendees = new PJQ.collections.meetings.MeetingAttendees(_.map(selectedContacts, function (contact) {
                        return new PJQ.models.meetings.MeetingAttendee({
                            id: contact.id,
                            attendee: contact
                        });
                    }, this));

                    this.model.isDirty = true;
                }, this)
            });
        } else {
            this.renderAttendanceDatatable();
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.meeting-file-uploader'),
            // useBlob: true,
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canView: false,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CONCLUDED && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CANCELLED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })

        this.recordingUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.meeting-recording-uploader'),
            allowedExtensions: ['wav', 'mpeg', 'mp3', 'webm'],
            collection: this.model.meetingRecordings,
            maxFiles: 1,
            canUpload: this.options.canUploadRecording && _.size(this.model.meetingRecordings) === 0,
            useApiV2: true,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CONCLUDED && this.model.get('statusId') !== PJQ.constants.meetings.meetingStatus.CANCELLED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                    this.model.save(null, {
                        success: _.bind(function (model) {
                            this.options.canUploadRecording = false;
                            this.render();
                        }, this)
                    });
                } else {
                    attachment.destroy();
                    this.options.canUploadRecording = false;
                    this.render();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })
    },
    renderAttendanceDatatable: function () {
        this.attendanceTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.meeting-attendees'),
            isHideSearch: true,
            data: this.model.attendees.models,
            rowId: "cid",
            order: [0, 'asc'],
            pageLength: 10,
            language: {
                zeroRecords: 'No Scheduled Attendees'
            },
            columns: [
                {
                    "data": "attributes.attendee",
                    "title": "Name",
                    "render": (data, type, row) => {
                        let result = '';
                        if (row.attendee != null) {
                            result = PJQ.helpers.contacts.getContactAnchor({
                                id: row.attendee.id,
                                name: row.attendee.get('contactName')
                            });
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.attendee",
                    "title": "Company",
                    "render": (data, type, row) => {
                        let result = '';
                        if (row.attendee != null) {
                            return row.attendee.get('companyName');
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.isPresent",
                    "title": "Present",
                    "width": "7%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isPresent"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
                {
                    "data": "attributes.isAbsent",
                    "title": "Absent",
                    "width": "7%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isAbsent"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
                {
                    "data": "attributes.isDistribution",
                    "title": "For Distribution Only",
                    "width": "18%",
                    "render": (data, type, row) => {
                        let html = ''
                        if (this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS && (!PJQ.app.session.project || PJQ.app.session.project.hasPermission('meetings.canEdit'))) {
                            html = '<div class="pretty p-switch ml-3"><input type="radio" name="attendance-' + row.cid + '" ' + (data ? 'checked' : '') + ' class="cb-primary toggle-attendance" data-attribute="isDistribution"/><div class="state p-success"><label>&nbsp;</label></div></div>';
                        } else {
                            html = data ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        }

                        return '<div class="wd-100 text-align-center">' + (html) + '</div>'
                    }
                },
            ]
        });
    },
    toggleAttendance: function (e) {
        let target = $(e.currentTarget),
            attribute = target.data('attribute'),
            attendee = this.attendanceTable.getRow(target.closest('tr')).data();

        attendee.set({
            isPresent: attribute === 'isPresent',
            isAbsent: attribute === 'isAbsent',
            isDistribution: attribute === 'isDistribution'
        });
    },
    viewTranscription: function () {
        let recordings = _.filter(this.model.meetingRecordings.models, function (recording) {
                return !recording.get('delete')
            }, this),
            recording = recordings[0];

        new PJQ.views.meetings.ViewMeetingTranscriptionModal({
            model: recording,
            meeting: this.model
        });
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, false);
    },
    renderAgendaItems: function () {
        let categories = _.sortBy(this.model.categories.models, function (c) {
                return c.id == null ? -1 : c.id;
            }),
            categoryIds = [],
            hasUncategorizedItems = this.model.agendaItems.findWhere({categoryId: null}) != null;
        _.each(categories, _.bind(function (c) {
            if (c.id > 0 || null != this.model.agendaItems.findWhere({categoryId: c.id})) {
                categoryIds.push(c.id);
            }
        }, this));

        this.renderSubTemplate(false, this.options.subTemplates.agendaItems, this.$('.meeting-agenda'), {
            subTemplates: this.options.subTemplates,
            items: this.model.agendaItems.models,
            meetings: this.options.meetings,
            categories: categories,
            settings: this.settings,
            meeting: this.model,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            canEditMinutes: this.options.canEditMinutes,
        }, _.bind(function (el) {
            _.each(this.model.agendaItems.models, function (model) {
                let category = this.model.categories.get(model.get('categoryId')),
                    agendaNumber;

                if (category) {
                    let sortNumber = hasUncategorizedItems ? category.get('sortOrder') + 1 : category.get('sortOrder');
                    agendaNumber = sortNumber + "." + model.get('sortOrder');
                } else {
                    agendaNumber = "1." + model.get('sortOrder');
                }

                this.renderAgendaItem(model, agendaNumber);
            }, this);
        }, this));


        if (this.options.canEdit) {
            let categorySortable = new PJQ.Sortable(this.$('.agenda-items-container'), {
                items: '.category-dropdown',
                multiple: false,
                tolerance: 'pointer',
                handle: '.category-sort',
                onStart: () => {
                    this.$('.collapse').hide();
                    categorySortable.refreshPositions();
                },
                onStop: (e, ui) => {
                    this.setCategorySort(ui.item);
                }
            });

            let agendaSortable = new PJQ.Sortable(this.$('.collapse'), {
                items: '.agenda-item-outer',
                multiple: false,
                tolerance: 'pointer',
                handle: '.agenda-item-sort',
                onStart: () => {
                    agendaSortable.refreshPositions();
                },
                onStop: (e, ui) => {
                    this.setAgendaItemSort(ui.item);
                }
            });
        }
    },
    setAgendaItemSort: function (sortedEl) {
        let sortOrder = 1,
            collapseEl = this.$(sortedEl).closest('.collapse'),
            sortedCid = this.$(sortedEl).data('cid'),
            sortedItem = this.model.agendaItems.get(sortedCid),
            updateSort = false;

        _.each(collapseEl.find('.agenda-item-outer'), function (element) {
            let itemCid = this.$(element).data('cid');
            let agendaItem = this.model.agendaItems.get(itemCid);

            if (agendaItem) {
                if (agendaItem === sortedItem && sortedItem.get('sortOrder') !== sortOrder) {
                    updateSort = true;
                }

                agendaItem.set('sortOrder', sortOrder);
                sortOrder++;
            }
        }, this);

        if (updateSort) {
            sortedItem.updateSort();
        }

        this.renderAgendaItems();
    },
    setCategorySort: function (sortedEl) {
        let categories = this.model.categories.models,
            sortOrder = 1,
            sortedCid = this.$(sortedEl).data('cid'),
            sortedCategory = this.model.categories.get(sortedCid),
            updateSort = false;

        _.each(this.$('.category-dropdown'), function (category) {
            let cid = this.$(category).data('cid'),
                model = _.find(categories, function (c) {
                    return c.cid === cid;
                });

            if (model) {
                if (model === sortedCategory && model.get('sortOrder') !== sortOrder) {
                    updateSort = true;
                }

                model.set('sortOrder', sortOrder);
                sortOrder++;
            }
        });

        if (updateSort) {
            sortedCategory.updateSort();
        }
        this.renderAgendaItems();
    },
    renderAgendaItem: function (agendaItem, agendaNumber) {
        if (!agendaNumber && agendaItem.agendaNumber != null) {
            agendaNumber = agendaItem.agendaNumber;
        }
        agendaItem.agendaNumber = agendaNumber;

        let $item = this.$('.agenda-item-outer[data-cid="' + agendaItem.cid + '"]');
        this.renderSubTemplate(false, this.options.subTemplates.agendaItem, $item, {
            model: agendaItem,
            canEdit: this.options.canEdit,
            settings: this.settings,
            canEditMinutes: this.options.canEditMinutes,
            canDelete: this.options.canDelete,
            agendaNumber: agendaItem.agendaNumber,
            meetings: this.options.meetings,
        }, _.bind(function (el) {
            let $agendaItemEl = el.find('.agenda-item-container[data-cid="' + (agendaItem.cid) + '"]');

            if (agendaItem.get('isEditing')) {
                agendaItem.minutesEditor = new PJQ.inputs.HTMLEditor({
                    el: $agendaItemEl.find('.meeting-minutes-edit'),
                    defaultValue: agendaItem.get('minutes'),
                    editorHeight: 100,
                    isHideTokens: true,
                    onChange: (val) => {
                        agendaItem.set('minutes', val);
                    }
                });

                el.find('.note-editor').addClass('wd-100');
            }


            agendaItem.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $agendaItemEl.find('.agenda-item-attachments'),
                // useBlob: true,
                collection: agendaItem.attachments,
                canUpload: this.options.canEditMinutes,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    agendaItem.isDirty = true;
                }, this),
                onDelete: (attachment, callback) => {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    agendaItem.isDirty = true;
                    callback();
                }
            })
        }, this));
    },
    categoryClicked: function (e) {
        let dropdown = $(e.currentTarget),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid),
            collapse = dropdown.next('.collapse'),
            caret = dropdown.find('.category-caret')

        if (!collapse.hasClass('show')) {
            caret.find('i').removeClass('fa-caret-right').addClass('fa-caret-down')
            category.set('isExpanded', true);
        } else {
            caret.find('i').removeClass('fa-caret-down').addClass('fa-caret-right')
            category.set('isExpanded', false);
        }
    },
    editMeetingMinutes: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);

        agendaItem.set('isEditing', true);
        this.renderAgendaItems();
    },
    exportMeeting: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});

            this.renderAgendaItems();
        }, this);

        if (this.options.canEdit) {
            this.save(callback);
        } else {
            callback();
        }
    },
    distributeAgendaItems: function () {
        let isMinutes = this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.CONCLUDED || this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS;
        new PJQ.views.modals.YesNo({
            header: "Distribute " + (isMinutes ? "Meeting Minutes?" : "Meeting Agenda?"),
            body: "This will email all attendees the " + (isMinutes ? "meeting minutes" : "agenda") + " for this meeting. Would you like to continue?",
            onYes: _.bind(function () {
                this.model.save(null, {
                    success: _.bind(function () {
                        new PJQ.ajax.Request({
                            isAPIv2: true,
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'meetings',
                                    value: this.model.get('id')
                                },
                                {
                                    endpoint: 'email'
                                }
                            ]),
                        }).post().done(_.bind(function (response) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Successfully distributed'
                            });
                        }, this)).fail(_.bind(function (xhr, err, result) {
                            PJQ.notifications.notify.errorNotify({
                                message: "Encountered an error while distributing this meeting. Please contact customer service."
                            });
                        }, this));
                    }, this)
                }, this)
            }, this)
        });
    },
    distributeAgendaItemsManual: function () {
        let isMinutes = this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.CONCLUDED || this.model.get('statusId') === PJQ.constants.meetings.meetingStatus.IN_PROGRESS;

        let subjectTmpl = this.settings.get('defaultEmailSubject');
        if (_.size(subjectTmpl) === 0) {
            subjectTmpl = `${isMinutes ? "Meeting Minutes" : "Meeting Agenda"} for [meeting.name] on [meetingDate] for [project.projectName]`;
        }
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: `Distribute ${isMinutes ? "Meeting Minutes" : "Meeting Agenda"}`,
            subjectTemplate: subjectTmpl,
            selectedEmailsTo: _.compact(_.map(this.model.attendees.models, function (attendee) {
               let person = attendee.attendee;
               if(PJQ.helpers.validators.validateEmail(person.get('email')).success){
                     return person.get('email');
               }
            })),
            tokens: {
                project: PJQ.app.session.project.attributes,
                meeting: this.model.attributes,
                meetingDate: PJQ.helpers.dateHelpers.getDateString(new Date(this.model.get('date')) , PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                meetingStartTime: this.timeStringTo12Hour(this.model.get('startTime')),
                meetingEndTime: this.timeStringTo12Hour(this.model.get('endTime'))
            },
            onSave: (data) => {
                this.model.distribute(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: `Successfully distributed ${isMinutes ? "Meeting Minutes" : "Meeting Agenda"}`
                    });
                }, this));
            }
        });
    },
    timeStringTo12Hour: function (timeString) {
        let [h, m] = timeString.split(':');
        h = +h;
        const ampm = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        return `${h}:${m} ${ampm}`;
    },
    saveMeetingMinutesClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.saveMeetingMinutes(agendaItem);
        this.renderAgendaItems();
    },
    saveMeetingMinutes: function (agendaItem) {
        if (agendaItem == null || agendaItem.minutesEditor == null) {
            return;
        }

        agendaItem.save({
            minutes: agendaItem.minutesEditor.getValue(),
            isEditing: false
        });
    },
    saveOpenMinutes: function () {
        _.each(this.model.agendaItems.models, (agendaItem) => {
            if (agendaItem.get('isEditing') !== true) {
                return;
            }

            this.saveMeetingMinutes(agendaItem);
        });
        this.renderAgendaItems();
    },
    cancelMeetingMinutes: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);

        agendaItem.set('isEditing', false);
        this.renderAgendaItems();
    },
    addCategoryClicked: function (e) {
        let category = new PJQ.models.meetings.MeetingCategory({
            meetingId: this.model.id
        })

        this.editCategory(category);
    },
    editCategoryClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            dropdown = target.closest('.category-dropdown'),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid);

        this.editCategory(category);
    },
    deleteCategoryClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            dropdown = target.closest('.category-dropdown'),
            cid = dropdown.data('cid'),
            category = this.model.categories.get(cid);

        this.deleteCategory(category);
    },
    editCategory: function (category) {
        new PJQ.views.meetings.CategoryEditModal({
            meeting: this.model,
            model: category,
            onDelete: _.bind(function (category) {
                this.model.categories.remove(category);
                this.renderAgendaItems();
            }, this),
            onSave: _.bind(function (category, isNew) {
                if (isNew) {
                    this.model.categories.add(category);
                }
                this.renderAgendaItems();
            }, this)
        });
    },
    deleteCategory: function (category) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this category?  This will also delete any items in the category.",
            onDelete: _.bind(function () {
                category.destroy({
                    success: _.bind(function () {
                        this.model.agendaItems.remove(_.filter(this.model.agendaItems.models, function (model) {
                            return model.get('categoryId') === category.id;
                        }, this));
                        this.model.categories.remove(category);
                        this.renderAgendaItems();
                    }, this)
                })
            }, this)
        });
    },
    addAgendaItemClicked: function (e) {
        e.stopPropagation();
        let categoryId = $(e.currentTarget).data('category-id'),
            categoryAgendaItems = this.model.agendaItems.where({categoryId: categoryId == null ? null : categoryId});

        let agendaItem = new PJQ.models.meetings.AgendaItem({
            meetingId: this.model.id,
            priorityId: 1,
            statusId: 1,
            categoryId: categoryId && categoryId !== '' ? parseInt(categoryId) : null,
            sortOrder: _.size(categoryAgendaItems) + 1
        });

        this.editAgendaItem(agendaItem);
    },
    closeAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        agendaItem.set('statusId', PJQ.constants.meetings.meetingAgendaStatus.CLOSED);
        agendaItem.save();
        this.renderAgendaItem(agendaItem);
    },
    openAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        agendaItem.set('statusId', PJQ.constants.meetings.meetingAgendaStatus.OPEN);
        agendaItem.save();
        this.renderAgendaItem(agendaItem);
    },
    editAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.editAgendaItem(agendaItem);
    },
    editAgendaItem: function (agendaItem) {
        new PJQ.views.meetings.AgendaItemEditModal({
            meeting: this.model,
            model: agendaItem,
            onDelete: _.bind(function (agendaItem) {
                this.model.agendaItems.remove(agendaItem);
                this.renderAgendaItems();
            }, this),
            onSave: _.bind(function (agendaItem, isNew) {
                if (isNew) {
                    this.model.agendaItems.add(agendaItem);
                    this.renderAgendaItems();
                } else {
                    this.renderAgendaItems();
                }
            }, this)
        });
    },
    deleteAgendaItemClicked: function (e) {
        let $agendaItemContainer = $(e.currentTarget).closest('.agenda-item-container'),
            cid = $agendaItemContainer.data('cid'),
            agendaItem = this.model.agendaItems.get(cid);
        this.deleteAgendaItem(agendaItem);
    },
    deleteAgendaItem: function (agendaItem) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this agenda item?",
            onDelete: _.bind(function () {
                this.model.agendaItems.remove(agendaItem);
                agendaItem.destroy();
                this.renderAgendaItems();
            }, this)
        });
    },
    validate: function () {
        let isValid = true;

        if (this.meetingCustomFieldsForm != null && !this.meetingCustomFieldsForm.validate()) {
            isValid = false;
        }

        let $meetingName = this.$('.meeting-name');
        PJQ.helpers.inputHelpers.setInputError($meetingName, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingName, false);
            isValid = false;
        }

        let $meetingNumber = this.$('.meeting-number');
        PJQ.helpers.inputHelpers.setInputError($meetingNumber, true);
        if (this.model.get('number') == null || this.model.get('number').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingNumber, false);
            isValid = false;
        }

        let $meetingDate = this.$('.meeting-date');
        PJQ.helpers.inputHelpers.setInputError($meetingDate, true);
        if (PJQ.app.session.project && (this.model.get('date') == null || this.model.get('date').length === 0)) {
            PJQ.helpers.inputHelpers.setInputError($meetingDate, false);
            isValid = false;
        }

        let $meetingStartTime = this.$('.meeting-start-time');
        PJQ.helpers.inputHelpers.setInputError($meetingStartTime, true);
        if (this.model.get('startTime') == null || this.model.get('startTime').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingStartTime, false);
            isValid = false;
        }

        let $meetingEndTime = this.$('.meeting-end-time');
        PJQ.helpers.inputHelpers.setInputError($meetingEndTime, true);
        if (this.model.get('endTime') == null || this.model.get('endTime').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($meetingEndTime, false);
            isValid = false;
        }
        return isValid;
    },
    saveMeeting: function () {
        let isNew = this.model.isNew(),
            callback = _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Meeting saved successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model, isNew);

                if (!isNew) {
                    this.removeModal();
                } else {
                    this.render();
                }
            }, this);

        this.saveOpenMinutes();
        this.save(callback, isNew);
    },
    save: function (callback, isNew) {
        if (!this.validate()) {
            return;
        }

        if (this.fileUploader.isUploading() || this.recordingUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            return;
        }

        if (!this.model.get('attendeeIds')) {
            this.model.set('attendeeIds', []);
        }

        this.model.set('customFieldValues', this.meetingCustomFieldsForm != null ? this.meetingCustomFieldsForm.getChanged() : null);

        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Meeting. Please contact customer service."
                });
            }, this)
        })
    },
    deleteMeeting: function () {
        let meetingId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this meeting?",
            onDelete: _.bind(function () {
                this.model.destroy();
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete();
                    this.removeModal();
                }
            }, this)
        });
    },
    close: function () {
        if ((this.model.hasChanged() || 0 < _.size(this.model.agendaItems.getChangedModels())) && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveMeeting();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.meetings.AgendaItemEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-agenda-item-edit'),
        width: '65%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveAgendaItem',
        'click .btn-delete': 'deleteAgendaItem',
        'click .btn-close': 'close',
        'input .agenda-item-description': 'descriptionChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        if (PJQ.app.session.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }

        if (!this.model) {
            this.model = new PJQ.models.meetings.AgendaItem();
        }

        if (this.options.project) {
            this.settings = await this.options.project.fetchMeetingSettings();
        } else {
            this.settings = await PJQ.app.session.fetchMeetingSettings();
        }
        this.isFetched = true;

        this.render();
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings,
            meeting: this.options.meeting,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });
        let defaultDate = PJQ.helpers.dateHelpers.getDateString(this.model.get('dueDate'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            timezone: 'UTC',
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: defaultDate
            },
            onChange: _.bind(function (newDate) {
                let currentDate = this.model.get('date');
                if (currentDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDate)) !== 0) {
                    this.model.set('dueDate', newDate);
                }
            }, this)
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 1,
            canEdit: true,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newStatus = value;
                this.model.set('statusId', newStatus);
            }, this)
        });

        if (!this.settings.get('disableAgendaItemPriority')) {
            this.priorityPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-priority'),
                defaultValue: this.model.get('priorityId') != null ? this.model.get('priorityId') : 1,
                canEdit: true,
                isMultiple: false,
                isIntChoices: true,
                onChange: _.bind(function (value) {
                    let newPriority = value;
                    this.model.set('priorityId', newPriority);
                }, this)
            });
        }

        this.categoryPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-category'),
            defaultValue: this.model.get('categoryId'),
            canEdit: true,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                let newCategory = value;
                this.model.set('categoryId', newCategory);
            }, this)
        });

        this.assigneePicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.agenda-assigned-to'),
            selectedContact: this.model.assignedTo,
            isReadOnly: !this.options.canEdit,
            displayContactsBlock: true,
            context: PJQ.app.session.project ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: true,
            onChange: _.bind(function (selectedContact) {
                this.model.isDirty = true;
                this.model.assignedTo = selectedContact;
                this.model.set('assignedToId', selectedContact ? selectedContact.get('id') : null);
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.agenda-item-file-uploader'),
            // useBlob: true,
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            useApiV2: true,
            canView: false,
            canDelete: this.options.isAdmin,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        })
    },
    descriptionChanged: function(e) {
        let $input = $(e.currentTarget),
            val = $input.val();

        if (typeof val === 'string' && val.length > 4000) {
            val = val.slice(0, 4000);
            $input.val(val);
        }

        this.model.set('description', val);
    },
    validate: function () {
        let isValid = true;

        let $agendaTitle = this.$('.agenda-item-title');
        PJQ.helpers.inputHelpers.setInputError($agendaTitle, true);
        if (this.model.get('title') == null || this.model.get('title').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($agendaTitle, false);
            isValid = false;
        }

        return isValid;
    },
    saveAgendaItem: function () {
        if (!this.validate()) {
            return;
        }
        let isNew = this.model.isNew();
        let callback = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave(this.model, isNew);

            this.removeModal();
        }, this);

        this.save(callback);
    },
    save: function (callback) {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
            return;
        }

        if (!this.model.get('assignedToId')) {
            this.model.set('assignedToId', 0);
        }

        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this category. Please contact customer service."
                });
            }, this)
        })
    },
    deleteAgendaItem: function () {
        let agendaItemId = this.model.id;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this agenda item?",
            onDelete: _.bind(function () {
                this.model.destroy();
                if (typeof this.options.onDelete === 'function')
                    this.options.onDelete(this.model);

                this.removeModal();
            }, this)
        });
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.meetings.CategoryEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-category-edit'),
        width: '40%',
        maxWidth: 600,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save': 'saveCategory',
        'click .btn-delete': 'deleteCategory',
        'click .btn-close': 'close',
    },
    beforeModalCreated: function () {
        if (PJQ.app.session.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.canEdit');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }

        this.isFetched = false;

        if (!this.model) {
            this.model = new PJQ.models.meetings.MeetingCategory();
        }

        if (!this.model.isNew() && !this.model.isFetched) {
            this.model.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            model: this.model,
            meeting: this.options.meeting,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            watchElements: [
                'input',
            ]
        });
    },
    validate: function () {
        let isValid = true;

        let $categoryName = this.$('.category-name');
        PJQ.helpers.inputHelpers.setInputError($categoryName, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($categoryName, false);
            isValid = false;
        }

        return isValid;
    },
    saveCategory: function () {
        if (!this.validate()) {
            return;
        }
        let isNew = this.model.isNew();
        let callback = _.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Category saved successfully'
            });

            if (typeof this.options.onSave === 'function')
                this.options.onSave(this.model, isNew);

            this.removeModal();
        }, this);

        this.save(callback);
    },
    save: function (callback) {
        this.model.save(null, {
            success: _.bind(function () {
                if (typeof callback === 'function') {
                    callback();
                }
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this category. Please contact customer service."
                });
            }, this)
        })
    },
    deleteCategory: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this category?  This will also delete any items in the category.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(this.model);

                        this.removeModal();
                    }, this),
                    error: _.bind(function () {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Something went wrong!'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveCategory();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.meetings.ViewMeetingTranscriptionModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'modal-view-transcription'),
        width: '50%',
        maxWidth: 800,
        model: null,
        isShowCloseButton: true,
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-transcribe': 'transcribeMeeting'
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            recording: this.model,
            meeting: this.options.meeting
        }
    },
    afterRender: function () {

    },
    transcribeMeeting: function () {
        this.loader = new PJQ.Loader(this.$('.generate-transcription-div'));
        new PJQ.ajax.Request({
            isAPIv2: true,
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'meetings',
                    value: this.options.meeting.id
                },
                {
                    endpoint: 'transcribe'
                }
            ]),
        }).get().done(_.bind(function (response) {
            this.model.set('transcriptions', [response]);
            this.loader.remove()
            PJQ.notifications.notify.successNotify({
                message: 'Recording successfully transcribed'
            });
            this.render();
        }, this)).fail(_.bind(function (xhr, err, result) {//todo: error
        }, this));
    },
    close: function () {
        this.removeModal();
    }
});